<div class="flexbox-column gap-0 h-100 overflow-hidden" (click)="$event.stopPropagation()" appSpin [spinnerConfig]="spinnerConfig()"
  (keydown.tab)="$event.stopPropagation()" (keydown.shift.tab)="$event.stopPropagation()" tabindex="-1">
  <!-- New Map No. Start -->
  <ng-container *ngIf="isActiveNewMap">
    <div class="flexbox-column gap-0 h-100 overflow-hidden">
      <div class="title-block vertical-items align-items-center px-3 gap-8">
        <button mat-button class="button-medium-icon" *ngIf="!isEditMapNo"
          (click)="$event.stopPropagation();backToMap('ADD')">
          <i class="fa-regular fa-arrow-left"></i>
        </button>
        <button mat-button class="button-medium-icon" *ngIf="isEditMapNo"
          (click)="$event.stopPropagation();backToMap('EDIT')">
          <i class="fa-regular fa-arrow-left"></i>
        </button>
        <div>
          <h6 class="title">{{isEditMapNo ? 'Edit Map No.' : 'Add New Map No.'}}</h6>
        </div>
      </div>
      <div class="flexbox-column px-3 flex-1 overflow-auto border-top">
        <div class="text1">
          <p class="vertical-items gap-8 align-items-center p-2 w-100" *ngIf="isShowMapError">
            <i class="fa-regular fa-triangle-exclamation text-warning"></i>
            You haven't saved the details below!
          </p>
          <p class="vertical-items gap-8 align-items-center p-2 w-100" *ngIf="mapNoForm.get('mapNo').errors?.uniqueMapno">
            <i class="fa-regular fa-triangle-exclamation text-warning"></i>
            Already Exists Map No.
          </p>
          <p class="vertical-items gap-8 align-items-center p-2 w-100" *ngIf="mapNoForm.get('mapNo').errors?.pattern">
            <i class="fa-regular fa-triangle-exclamation text-warning"></i>
            Invalid Map No.
          </p>
          <p class="vertical-items gap-8 align-items-center p-2 w-100"
            *ngIf="mapNoForm.get('description').errors?.maxlength"></p>
        </div>
        <form class="horizontal-items" [formGroup]="mapNoForm">
          <div class="ng-form-field w-100 required">
            <label>Group</label>
            <ng-select (keydown.arrowdown)="$event.stopPropagation()" (keydown.arrowup)="$event.stopPropagation()"
              [items]="groups" bindLabel="fingroupname" bindValue="fingroupid" [selectOnTab]="true" [virtualScroll]="true"
              [clearable]="false" formControlName="group" placeholder="" (change)="getSubGroups();onChangeGroup($event)"
              title="{{groupTitle}}" [ngClass]="{'map-disabled1': isEditMapNo}" class="map-head-dropdown firm-input-field"
              required>
              <ng-template ng-option-tmp let-item="item">
                <div title="{{item.fingroupname}}">{{item.fingroupname}}</div>
              </ng-template>
            </ng-select>
          </div>
          <div class="ng-form-field w-100 required">
            <label>Sub Group</label>
            <ng-select (keydown.arrowdown)="$event.stopPropagation()" (keydown.arrowup)="$event.stopPropagation()"
              [items]="subGroups" bindLabel="finsubgroupname" bindValue="finsubgroupid" [selectOnTab]="true"
              [virtualScroll]="true" [clearable]="false" formControlName="subGroup" placeholder=""
              (change)="getCatsLsGifi();onChangeSubGroup($event)" title="{{subgroupTitle}}"
              class="map-head-dropdown firm-input-field" required>
              <ng-template ng-option-tmp let-item="item">
                <div title="{{item.finsubgroupname}}">{{item.finsubgroupname}}</div>
              </ng-template>
            </ng-select>
          </div>
          <div class="ng-form-field w-100 required">
            <label>Category</label>
            <ng-select class="category-select" (keydown.arrowdown)="$event.stopPropagation()" (keydown.arrowup)="$event.stopPropagation()"
              [items]="categories" formControlName="category" bindLabel="mapno" bindValue="mapno" placeholder=""
              [selectOnTab]="true" [clearable]="false" (focusout)="showCategoryDropdown()"
               title="{{categoryTitle}}" required>
               <ng-template ng-header-tmp>
                <div class="category-panel">
                <div class="heading-category flexbox-row" style="cursor: default;"
                (click)="$event.stopPropagation()">
                <div class="left">
                  <h6>Category</h6>
                </div>
                <div class="right">
                  <h6>Description</h6>
                </div>
              </div>
              </div>
            </ng-template>
              <ng-template ng-option-tmp let-item="item" let-index="index" let-search="searchTerm">
                <div class="category-menu" (click)="appendCategory(item)"
                  [ngClass]="{'matoption':showCategory}">
                  <div class="category-panel">
                    <div class="body-category flexbox-row">
                      <div class="left" title="{{item.mapno}}">
                        <p class="ellipse no-marg"> {{item.mapno}}</p>
                      </div>
                      <div class="right" title="{{item.description}}">
                        <p class="ellipse no-marg"> {{item.description}}</p>
                      </div>
                    </div>
                  </div>
                </div>
              </ng-template>
            </ng-select>
          </div>
          <mat-form-field class="fixed-label w-100" floatLabel="always" [ngClass]="{'map-disabled': isEditMapNo}">
            <mat-label>Map No. </mat-label>

            <!-- <mat-label>Map No.<span style="color:#F5564B"> *</span> </mat-label> -->
            <input (click)="$event.stopPropagation()" matInput formControlName="mapNo" autocomplete="off"
              [readonly]="isEditMapNo" (keydown.enter)="$event.preventDefault()" />
          </mat-form-field>
          <mat-form-field class="fixed-label w-100" floatLabel="always">
            <mat-label>Description Notes </mat-label>

            <!-- <mat-label>Description Notes<span style="color:#F5564B"> *</span> </mat-label> -->
            <input matInput formControlName="description" autocomplete="off" maxlength="150"
              (keydown.enter)="$event.preventDefault()">
          </mat-form-field>
          <div class="ng-form-field w-100 required">
            <label>Leadsheet </label>
            <ng-select (keydown.arrowdown)="$event.stopPropagation()" (keydown.arrowup)="$event.stopPropagation()"
              [items]="leadSheets" bindLabel="leadsheetname" bindValue="leadsheetid" [selectOnTab]="true"
              [virtualScroll]="true" [clearable]="false" formControlName="leadSheet" placeholder=""
              (change)="getLSTitle($event)" title="{{leadSheetTitle}}" class="map-head-dropdown firm-input-field"
              required>
              <ng-template ng-option-tmp let-item="item">
                <div title="{{item.leadsheetname}}">{{item.leadsheetname}}</div>
              </ng-template>
            </ng-select>
          </div>
          <div class="ng-form-field w-100 required">
            <label>TAX Code </label>
            <ng-select (keydown.arrowdown)="$event.stopPropagation()" (keydown.arrowup)="$event.stopPropagation()"
              [items]="gifiCode" bindLabel="gifidescription" bindValue="gificode" [selectOnTab]="true"
              [virtualScroll]="true" [clearable]="false" formControlName="gifi" placeholder=""
              (change)="getGifiTitle($event)" title="{{gifiCodeTitle}}" class="map-head-dropdown firm-input-field"
              required>
              <ng-template ng-option-tmp let-item="item">
                <div title="{{item.gifidescription}}">{{item.gifidescription}}</div>
              </ng-template>
            </ng-select>
          </div>
          <input type="hidden" formControlName="masterMapSheetId">
        </form>
      </div>
      <div class="button-group justify-content-end p-3 border-top">
        <button mat-button mat-stroked-button color="dark" class="button-default flex-1"
          (click)="$event.stopPropagation();cancelMapNo()">
          Cancel
        </button>
        <button mat-button mat-flat-button class="button-default flex-1" color="primary"
          [ngClass]="{'disable-button': !mapNoForm.valid}" [disabled]="!mapNoForm.valid" (click)="saveNewMapNo()"
          *ngIf="!isEditMapNo"> Add
        </button>
        <button mat-button mat-flat-button class="button-default flex-1" color="primary"
          [ngClass]="{'disable-button': !mapNoForm.valid}" [disabled]="!mapNoForm.valid" (click)="updateMapNo()"
          *ngIf="isEditMapNo">
          Save
        </button>
      </div>
    </div>
  </ng-container>
  <!-- New Map No. end -->
  <!-- Map No. drop down start -->
  <ng-container *ngIf="!isActiveNewMap">

    <div class="flexbox-column gap-0 h-100 overflow-hidden">
      <div class="search-block flexbox-row p-2">
        <div class="ng-form-field flex-1 all-dropdwn mapno-drop-alll">
          <label>All</label>
          <ng-select [items]="searchDropdownData" #select class="all-dropdwn-selct checkbox-select-option"
            bindLabel="finsubgroupchildname" [bindValue]="leadsheetcode" groupBy="maping" placeholder=""
            [multiple]="true" [selectableGroup]="true" [closeOnSelect]="false" [virtualScroll]="true"
            [clearable]="false" [searchable]="selectedGroups.length > 2 ? false : true" [compareWith]="compareGroups"
            [(ngModel)]="selectedGroups" (change)="getMasterMaps(mapSearchTerm);isCloseAllDropdown = true"
            (open)="selectedGroups.length > 0 ? isCloseAllDropdown = true: isCloseAllDropdown = false"
            (blur)="isCloseAllDropdown ? getMasterMaps('') : ''">

            <ng-template ng-multi-label-tmp let-items="items" let-clear="clear">
              <div class="badge badge-small badge-pills badge-primary badge-border gap-2 mr-1" style="width:80px;"
                title="{{item.finsubgroupchildname || item.finsubgroupname}}" *ngFor="let item of items | slice:0:2">
                <span class="text-ellipse">{{item.finsubgroupchildname || item.finsubgroupname}}</span>
                <button mat-button class="button-text" (click)="clear(item);getMasterMaps('');selectedGroups.length > 0 ? isCloseAllDropdown = true: isCloseAllDropdown = false" aria-hidden="true">
                    <i class="fa-regular fa-xmark text-error"></i>
                </button>
              </div>
              <span class="ng-value-label" *ngIf="items.length > 2" (click)="openSelect(select)">+{{items.length - 2}} more</span>
            </ng-template>


            <ng-template let-index="index" let-item="item" let-item$="item$" ng-optgroup-tmp>
              <div class="vertical-items gap-4 align-items-center">
                <div class="custom-checkbox tbl_mapDropdownCr">
                  <input class="custom-checkbox-input" type="checkbox" [checked]="item$.selected">
                  <label class="check-box">
                    <i class="fa-regular fa-check text-primary"></i>
                  </label>
                </div>
                <!-- <mat-checkbox id="item-{{index}}" [ngModel]="item$.selected" ></mat-checkbox> -->
                <p class="item-title">{{item.finsubgroupname}}</p>
              </div>
            </ng-template>
            <ng-template let-index="index" let-item="item" let-item$="item$" ng-option-tmp>
              <div class="vertical-items gap-4 align-items-center">
                <div class="custom-checkbox tbl_mapDropdownCr">
                  <input class="custom-checkbox-input" type="checkbox" [checked]="item$.selected">
                  <label class="check-box">
                    <i class="fa-regular fa-check text-primary"></i>
                  </label>
                </div>
                <!-- <mat-checkbox id="item-{{index}}" type="checkbox" [ngModel]="item$.selected" ></mat-checkbox> -->
                <p class="item-title">{{item.finsubgroupchildname}}</p>
              </div>
            </ng-template>
          </ng-select>

        </div>
        <mat-form-field class="fixed-label  icon-field-before flex-1" floatLabel="always">
          <mat-label>Search</mat-label>
          <input matInput placeholder="Search" maxlength="20" size="20" #searchField [(ngModel)]="mapSearchTerm"
            [ngModelOptions]="{standalone: true}" (keyup)="handleSearch($event.target.value)" autocomplete="off">
          <span matPrefix>
            <i class="fa-regular fa-magnifying-glass" draggable="false"></i>
          </span>
        </mat-form-field>
      </div>

      <div class="template-block-main flex-1 overflow-hidden">
        <div class="flexbox-column gap-0 map-tabs w-100 flex-1 overflow-hidden">
          <button mat-button mat-flat-button color="primary" style="right:8px;" (click)="activeNewMap()"
            class="button-default add-new-button">
            <div class="flexbox-row gap-8">
                <i class="fa-solid fa-plus"></i>
                <span class="button-label">New</span>
            </div>
          </button>

          <mat-tab-group class="button-group-tabs flex-1 overflow-hidden" [selectedIndex]="mapTabIndex">
            <!-- All Tab Start -->
            <mat-tab (click)="$event.stopPropagation()">
              <ng-template mat-tab-label>
                <span title="All" (click)="$event.stopPropagation(); tabChanged('ALL')">
                  All
                </span>
              </ng-template>
              <ng-container>


                <ng-container *ngIf="allMaps && allMaps.length > 0; else noMapRecords">
                  <div class="table-outer w-100 h-100 overflow-auto">
                    <table mat-table [dataSource]="allMaps" [trackBy]="trackAllMaps"
                      class="mapping-tbl-grid table-countable">
                      <ng-container matColumnDef="checkbox">
                        <th mat-header-cell *matHeaderCellDef class="col-done-icon ps-2"></th>
                        <td mat-cell *matCellDef="let mapelement" class="col-done-icon ps-2">
                            <i class="fa-regular fa-check text-success" *ngIf="mapelement.mastermapsheetid === tbMapsheetId || mapelement.mastermapsheetid === mapsheetId"></i>
                        </td>
                      </ng-container>

                      <!-- mapno -->
                      <ng-container matColumnDef="mapno">
                        <th mat-header-cell *matHeaderCellDef class="map-col-mapno">Map No.</th>
                        <td mat-cell title="{{mapelement.mapno}}" *matCellDef="let mapelement" class="map-col-mapno">
                          <span class="ellipse">{{mapelement.mapno}}</span>
                        </td>
                      </ng-container>

                      <!-- mapsheetname -->
                      <ng-container matColumnDef="mapsheetname">
                        <th mat-header-cell *matHeaderCellDef class="map-col-mapname flex-1 overflow-hidden">Description
                        </th>
                        <td mat-cell title="{{mapelement.description}}"
                        class="map-col-mapname flex-1 overflow-hidden"
                        [ngClass]="{'pr-3 position-relative': mapelement?.description?.length >= 50}"
                        *matCellDef="let mapelement">
                        <span>{{mapelement.description}}</span>
                        <span *ngIf="mapelement?.description?.length >= 58" (click)="showMore($event)" class="badge-plus"></span>
                      </td>
                      </ng-container>

                      <!-- Subgroup -->
                      <ng-container matColumnDef="subgroup">
                        <th mat-header-cell *matHeaderCellDef class="map-col-mapsubgrop">Subgroup</th>
                        <td mat-cell title="{{mapelement.finsubgroupname}}" *matCellDef="let mapelement"
                          class="map-col-mapsubgrop">
                          <span class="ellipse">{{mapelement.finsubgroupname}}</span>
                        </td>
                      </ng-container>

                      <!-- unasgn -->
                      <ng-container matColumnDef="unasgn">
                        <th mat-header-cell *matHeaderCellDef class="map-col-unasgn"></th>
                        <td mat-cell *matCellDef="let mapelement" class="map-col-unasgn">
                          <button mat-button title="Un Assign" class="button-smaller-icon hover-action-item"
                            *ngIf="mapelement.mastermapsheetid === tbMapsheetId && moveType === 'SINGLE'"
                            (click)="unAssignMapNumber(parentObject);parentObject.isMap = false;">
                            <i class="fa-regular fa-arrow-rotate-left"></i>
                          </button>
                        </td>
                      </ng-container>

                      <!-- mapactions -->
                      <ng-container matColumnDef="mapactions">
                        <th mat-header-cell *matHeaderCellDef class="col-action pe-2"></th>
                        <td mat-cell *matCellDef="let mapelement" class="col-action pe-2">
                          <ng-container *ngIf="mapelement.ismastersource === 0">
                            <button mat-button class="button-smaller-icon hover-action-item kebab-button"
                              [matMenuTriggerFor]="allMenu" #closeAmapNo="matMenuTrigger"
                              (click)="$event.stopPropagation();mapObject = mapelement;">
                              <i class="fas fa-ellipsis-vertical"></i>
                            </button>
                          </ng-container>
                        </td>
                      </ng-container>
                      <tr mat-header-row *matHeaderRowDef="mappingColumns; sticky: true"></tr>
                      <tr mat-row *matRowDef="let row; columns: mappingColumns;"
                        (click)="row.mastermapsheetid != tbMapsheetId ? confirmSaveMapNo(parentObject, row, moveType) : '';">
                      </tr>
                    </table>
                  </div>
                </ng-container>

                <ng-template #noMapRecords>
                  <div class="no-data-found">
                    <img src="./assets/images/ui-uplift-icons/global/empty-component-icon.svg" alt="Icon">
                    <h6>No records found!</h6>
                  </div>
                </ng-template>

              </ng-container>
            </mat-tab>
            <!-- All Tab End -->
            <!-- New Tab Start -->
            <mat-tab (click)="$event.stopPropagation()">
              <ng-template mat-tab-label>
                <span title="Newly Added" (click)="$event.stopPropagation(); tabChanged('NEW')">
                  Newly Added
                </span>
              </ng-template>


              <ng-container *ngIf="newMaps && newMaps.length > 0; else noNewMapRecords">
                <div class="table-outer w-100 h-100 overflow-auto">
                  <table mat-table [dataSource]="newMaps" [trackBy]="trackNewMaps" class="table-countable hover-action">
                    <ng-container matColumnDef="checkbox">
                      <th mat-header-cell *matHeaderCellDef class="col-done-icon ps-2"></th>
                      <td mat-cell title="" *matCellDef="let mapelement" class="col-done-icon ps-2">
                        <i class="fa-regular fa-check text-success" *ngIf="mapelement.mastermapsheetid === tbMapsheetId || mapelement.mastermapsheetid === mapsheetId"></i>
                      </td>
                    </ng-container>

                    <!-- mapno -->
                    <ng-container matColumnDef="mapno">
                      <th mat-header-cell *matHeaderCellDef class="map-col-mapno">Map No.</th>
                      <td mat-cell title="{{mapelement.mapno}}" *matCellDef="let mapelement" class="map-col-mapno">
                        <span class="ellipse">{{mapelement.mapno}}</span>
                      </td>
                    </ng-container>

                    <!-- mapsheetname -->
                    <ng-container matColumnDef="mapsheetname">
                      <th mat-header-cell *matHeaderCellDef class="map-col-mapname">Description</th>
                      <td mat-cell title="{{mapelement.description}}"
                        class="map-col-mapname flex-1 overflow-hidden"
                        [ngClass]="{'pr-3 position-relative': mapelement?.description?.length >= 50}"
                        *matCellDef="let mapelement">
                        <span>{{mapelement.description}}</span>
                        <span *ngIf="mapelement?.description?.length >= 58" (click)="showMore($event)" class="badge-plus"></span>
                      </td>
                    </ng-container>

                    <!-- Subgroup -->
                    <ng-container matColumnDef="subgroup">
                      <th mat-header-cell *matHeaderCellDef class="map-col-mapsubgrop">Subgroup</th>
                      <td mat-cell title="{{mapelement.finsubgroupname}}" *matCellDef="let mapelement"
                        class="map-col-mapsubgrop">
                        <span class="ellipse">{{mapelement.finsubgroupname}}</span>
                      </td>
                    </ng-container>

                    <!-- unasgn -->
                    <ng-container matColumnDef="unasgn">
                      <th mat-header-cell *matHeaderCellDef class="col-unasgn"></th>
                      <td mat-cell *matCellDef="let mapelement" class="col-unasgn">
                        <button mat-button title="Un Assign" class="button-smaller-icon hover-action-item"
                          *ngIf="mapelement.mastermapsheetid === tbMapsheetId && moveType === 'SINGLE'"
                          (click)="unAssignMapNumber(parentObject);parentObject.isMap = false;">
                          <i class="fa-regular fa-arrow-rotate-left"></i>
                        </button>
                      </td>
                    </ng-container>

                    <!-- mapactions -->
                    <ng-container matColumnDef="mapactions">
                      <th mat-header-cell *matHeaderCellDef class="col-action pe-2"></th>
                      <td mat-cell *matCellDef="let mapelement" class="col-action pe-2">
                        <button mat-button class="button-smaller-icon hover-action-item kebab-button" [matMenuTriggerFor]="newMenu"
                          #closeNmapNo="matMenuTrigger" (click)="$event.stopPropagation();mapObject = mapelement;">
                          <i class="fas fa-ellipsis-vertical"></i>
                        </button>
                      </td>
                    </ng-container>
                    <tr mat-header-row *matHeaderRowDef="mappingColumns; sticky: true"></tr>
                    <tr mat-row *matRowDef="let row; columns: mappingColumns;"
                      (click)="row.mastermapsheetid != tbMapsheetId ? confirmSaveMapNo(parentObject, row, moveType) : '';">
                    </tr>
                  </table>
                </div>
              </ng-container>

              <ng-template #noNewMapRecords>
                <div class="no-data-found">
                  <img src="./assets/images/ui-uplift-icons/global/empty-component-icon.svg" alt="Icon">
                  <h6>No records found!</h6>
                </div>
              </ng-template>
            </mat-tab>
            <!-- New Tab End -->
          </mat-tab-group>
        </div>
      </div>
    </div>
  </ng-container>
  <!-- Map No. drop down end -->
</div>
<ng-template #deletedialog1>
  <div class="countable-dialog" (click)="$event.stopPropagation()" style="width: 400px;">
    <div class="dialog-header d-flex flex-column align-items-center">
      <span class="badge badge-error badge-circle icon-bordered-error">
        <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M6.5 1.5H11.5M1.5 4H16.5M14.8333 4L14.2489 12.7661C14.1612 14.0813 14.1174 14.7389 13.8333 15.2375C13.5833 15.6765 13.206 16.0294 12.7514 16.2497C12.235 16.5 11.5759 16.5 10.2578 16.5H7.74221C6.42409 16.5 5.76503 16.5 5.24861 16.2497C4.79396 16.0294 4.41674 15.6765 4.16665 15.2375C3.88259 14.7389 3.83875 14.0813 3.75107 12.7661L3.16667 4M7.33333 7.75V11.9167M10.6667 7.75V11.9167"
            stroke="#D92D20" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round" />
        </svg>
      </span>
    </div>
    <div class="content dialog-body-content text-center gap-8">
      <h4 class="title text-center">
        Delete Map No
      </h4>

      <p class="para-text">You are trying to delete Map Number {{deleteMapData.mapNo}}</p>
      <p class="para-text">Do you want to continue?</p>

    </div>
    <div mat-dialog-actions class="dialog-footer button-group w-100" (click)="$event.stopPropagation()">
      <button mat-button mat-stroked-button class="button-large flex-1" color="dark" [mat-dialog-close]>Cancel</button>
      <button mat-button mat-flat-button class="button-large flex-1 m-0" color="error" [mat-dialog-close]
        (click)="deleteMapNo()">Delete</button>
    </div>
  </div>

</ng-template>

<ng-template #workBookbulkmap>
  <div class="bulk-map-dailog" (click)="$event.stopPropagation()">
    <div class="heading">
      <h1 mat-dialog-title dialogbox>Bulk Mapping</h1>
      <button class="close-dialog transparent-btn" (click)="cancelBulkMap()" [mat-dialog-close] title="Close">
        <i class="fa-regular fa-xmark"></i>
      </button>
    </div>
    <div class="body" cdkDropListGroup>
      <div class="unmapped">
        <div class="heading">
          <h6>Unmapped Accounts</h6>
        </div>
        <div class="body">
          <table mat-table [dataSource]="unMappedData" class="unmapped-table" cdkDropList
            #unMappedDataList="cdkDropList" [cdkDropListConnectedTo]="[mappedDataList]" [cdkDropListData]="unMappedData"
            (cdkDropListDropped)="dropUnMappedData($event)">
            <ng-container matColumnDef="drag">
              <th mat-header-cell *matHeaderCellDef class="col-drag"></th>
              <td mat-cell *matCellDef="let element" class="col-drag">
                <button class="transparent-btn no-pad drag-btn" *ngIf="element.selected">
                    <i class="fa-solid fa-grip-dots-vertical"></i>
                </button>
              </td>
            </ng-container>
            <!-- Checkbox Column -->
            <ng-container matColumnDef="select">
              <th mat-header-cell *matHeaderCellDef class="col-chckbox">
                <mat-checkbox class="custom-checkbox greencheckbox" [(ngModel)]="unMappedData.checked"
                  [checked]="isAllUnMappedSelected" (ngModelChange)="isUnMappedSelectedAll(unMappedData)">
                </mat-checkbox>
              </th>
              <td mat-cell *matCellDef="let row" class="col-chckbox">
                <mat-checkbox class="custom-checkbox" [(ngModel)]="row.checked" [checked]="row.checked"
                  (ngModelChange)="selectedItemsChange(unMappedData)">
                </mat-checkbox>
              </td>
            </ng-container>

            <ng-container matColumnDef="accountcode">
              <th mat-header-cell *matHeaderCellDef class="col-accno">Acc No.</th>
              <td mat-cell *matCellDef="let element" title="{{element.accountcode}}" class="col-accno">
                <p class="ellipse no-marg"> {{element.accountcode}}</p>
              </td>
            </ng-container>

            <ng-container matColumnDef="accountname" class="col-accdesc">
              <th mat-header-cell *matHeaderCellDef class="col-accdesc"> Description </th>
              <td mat-cell *matCellDef="let element" title="{{element.accountname}}">
                <p class="ellipse no-marg"> {{element.accountname}} </p>
              </td>
            </ng-container>

            <ng-container matColumnDef="finalamount">
              <th mat-header-cell *matHeaderCellDef class="col-original">
                <div class="flex-box-vc-hr"> Original</div>
              </th>
              <td mat-cell *matCellDef="let element" class="col-original" title="{{element.finalamount}}">
                <div class="flex-box-vc-hr">
                  <p class="ellipse no-marg"> {{element.finalamount}} </p>
                </div>
              </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="unmappingColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: unmappingColumns;" [ngClass]="row.checked ? 'bold' : 'normal'"
              cdkDrag [cdkDragData]="row" class="draggable-row" (mouseover)="row.selected = true"
              (mouseout)="row.selected = false">
            </tr>
            <!-- [cdkDragDisabled]="selectedUnMappedData.length !== 1" -->
          </table>
          <ng-container *ngIf="noUnMappedRecord">
            <p class="no-data">There are no unmapped accounts</p>
          </ng-container>
        </div>
      </div>
      <div class="button">
        <button mat-flat-button class="flat-btn assgn-butn" color="primary" (click)="onAssignClick()"
          [disabled]="selectedUnMappedData.length === 0 || selectedMappedDatabase.length === 0">
          <i class="fa-regular fa-arrow-right"></i>
        </button>
      </div>
      <div class="database">
        <div class="heading">
          <h6>Mapping Database</h6>
        </div>
        <div class="body-database">
          <div class="mapno-bulk-dropdown-header">
            <div class="all-dropdwn ng-document-engagement">
              <label>All</label>
              <ng-select [items]="searchDropdownMappedData" #select class="all-dropdwn-selct"
                bindLabel="finsubgroupchildname" [bindValue]="leadsheetcode" groupBy="maping" placeholder=""
                [multiple]="true" [selectableGroup]="true" [closeOnSelect]="false" [virtualScroll]="true"
                [clearable]="false" [searchable]="selectedMappedGroups.length > 3 ? false : true"
                [compareWith]="compareGroups" [(ngModel)]="selectedMappedGroups" (change)="isCloseAllDropdown = true"
                (open)="selectedMappedGroups.length > 0 ? isCloseAllDropdown = true: isCloseAllDropdown = false"
                (blur)="isCloseAllDropdown ? mappingDatabaseDetails() : ''">

                <ng-template ng-multi-label-tmp let-items="items" let-clear="clear">
                  <div class="ng-value" *ngFor="let item of items | slice:0:2">
                    <span class="ng-value-label ellipse">{{item.finsubgroupchildname || item.finsubgroupname}}</span>
                    <span class="ng-value-icon right"
                      (click)="clear(item); mappingDatabaseDetails(); selectedMappedGroups.length > 0 ? isCloseAllDropdown = true: isCloseAllDropdown = false"
                      aria-hidden="true">×</span>
                  </div>
                  <div class="ng-value-more" *ngIf="items.length > 2">
                    <span class="ng-value-label">+{{items.length - 2}} more</span>
                  </div>
                </ng-template>
                <ng-template let-index="index" let-item="item" let-item$="item$" ng-optgroup-tmp>
                  <div class="subgrop access-check-box">
                    <input id="item-{{index}}" type="checkbox" [ngModel]="item$.selected" />
                    <!-- <mat-checkbox id="item-{{index}}" [ngModel]="item$.selected" color="primary"></mat-checkbox> -->
                    <p class="ellipse no-marg">{{item.finsubgroupname}}</p>
                  </div>
                </ng-template>
                <ng-template let-index="index" let-item="item" let-item$="item$" ng-option-tmp>
                  <div class="subgrop-child access-check-box">
                    <input id="item-{{index}}" type="checkbox" [ngModel]="item$.selected" />
                    <!-- <mat-checkbox id="item-{{index}}" [ngModel]="item$.selected" color="primary"></mat-checkbox> -->
                    <p class="ellipse no-marg">{{item.finsubgroupchildname}}</p>
                  </div>
                </ng-template>
              </ng-select>

            </div>
            <div class="search-field">
              <form>
                <label>Search</label>
                <input matInput #searchField placeholder="" [(ngModel)]="searchMapTerm"
                  [ngModelOptions]="{standalone: true}" (keyup)="bulkMapSearch($event.target.value)" autocomplete="off">
                <button class="transparent-btn search-btn">
                    <i class="fa-regular fa-magnifying-glass search-icon"></i>
                </button>
              </form>
            </div>
          </div>
          <div class="table-header">
            <div class="col-mapno">
              <h6>Map No.</h6>
            </div>
            <div class="col-desc">
              <h6>Description</h6>
            </div>
            <div class="col-subgroup">
              <h6>SubGroup</h6>
            </div>
            <div class="col-original flex-box-vc-hr">
              <h6>Original</h6>
            </div>
          </div>
          <div class="table-body" id="bulkMapGrid">
            <mat-accordion multi="true">
              <ng-container *ngIf="noMappedRecord">
                <p class="no-data">No Mapping Records found</p>
              </ng-container>
              <ng-container *ngFor="let mappedData of mappedDatabaseDetails">
                <mat-expansion-panel cdkDropList #mappedDataList="cdkDropList" id="{{mappedData.mapno}}"
                  [cdkDropListData]="mappedData" [cdkDropListConnectedTo]="[unMappedDataList]"
                  (cdkDropListDropped)="dropUnMappedData($event)" [expanded]="mappedData.isexpand"
                  (opened)="mappedData.showContent = true" (closed)="mappedData.showContent = false" #openExpansionPanel
                  (mouseenter)="mouseEnterHandler($event, openExpansionPanel)">
                  <mat-expansion-panel-header (click)="selectedMappedRecord(mappedData)"
                    [ngClass]="{'expansionclass' : mappedData.isunassign === 'true', 'closedclass' : mappedData.isunassign === 'false', 'selectedRow' : mappedData.selected === true} ">
                    <div class="header-details">
                      <!--<div class="main-add-btn">
                        <div class="add-btn" *ngIf="mappedData.isunassign === 'true'">

                          <button class="transparent-btn no-pad add-minus" *ngIf="mappedData.showContent === false">
                                    <i class="fa-solid fa-plus"></i>
                          </button>
                          <button class="transparent-btn no-pad add-minus" *ngIf="mappedData.showContent === true">
                            <i class="fa-solid fa-minus"></i>
                          </button>
                        </div>
                      </div>-->
                      <div class="mapno">
                        <p class="ellipse no-marg">{{mappedData.mapno}}</p>
                      </div>
                      <div class="mapdescription">
                        <p class="ellipse no-marg">{{mappedData.description}}</p>
                      </div>
                      <div class="subgroup">
                        <p class="ellipse no-marg">{{mappedData.finsubgroupname}}</p>
                      </div>
                      <div class="original flex-box-vc-hr">
                        <p class="ellipse no-marg"></p>
                      </div>
                      <div class="unassign" *ngIf="mappedData.isunassign === 'true'">
                        <button class="transparent-btn no-pad unasgn-btn"
                          (click)="openUnAssignPopUp(mappedData, 'all')">
                        </button>
                      </div>
                    </div>
                  </mat-expansion-panel-header>
                  <div class="mapno-details" *ngIf="mappedData.isexpand === 'true'">
                    <ng-container>
                      <table mat-table [dataSource]="mappedData.tbrecords" class="mapping-tbl-grid" cdkDropList
                        [cdkDropListConnectedTo]="connectedTo" [cdkDropListData]="mappedData.tbrecords"
                        (cdkDropListDropped)="dropMappedData($event)">
                        <ng-container matColumnDef="drag">
                          <th mat-header-cell *matHeaderCellDef class="col-dragg"></th>
                          <td mat-cell *matCellDef="let element" class="col-dragg">
                            <button class="transparent-btn no-pad drag-btn" *ngIf="element.selected">
                                <i class="fa-solid fa-grip-dots-vertical"></i>
                            </button>
                          </td>
                        </ng-container>
                        <ng-container matColumnDef="mapno">
                          <th mat-header-cell *matHeaderCellDef class="col-mapno"></th>
                          <td mat-cell title="{{mapelement.accountcode}}" *matCellDef="let mapelement"
                            class="col-mapno">
                            <p class="ellipse no-marg">{{mapelement.accountcode}}</p>
                          </td>
                        </ng-container>

                        <ng-container matColumnDef="mapdescription">
                          <th mat-header-cell *matHeaderCellDef class="col-mapdescription"></th>
                          <td mat-cell *matCellDef="let mapelement" class="col-mapdescription"
                            title="{{mapelement.accountname}}">
                            <p class="ellipse no-marg">{{mapelement.accountname}}</p>
                          </td>
                        </ng-container>
                        <ng-container matColumnDef="subgroup">
                          <th mat-header-cell *matHeaderCellDef class="col-subgroup"></th>
                          <td mat-cell *matCellDef="let mapelement" class="col-subgroup" title="">
                            <p class="ellipse no-marg"></p>
                          </td>
                        </ng-container>
                        <ng-container matColumnDef="maporiginal">
                          <th mat-header-cell *matHeaderCellDef class="col-maporiginal"></th>
                          <td mat-cell *matCellDef="let mapelement" title="{{mapelement.finalamount}}">
                            <div class="flex-box-vc-hr">
                              <p class="ellipse no-marg"> {{mapelement.finalamount}}</p>
                            </div>
                          </td>
                        </ng-container>
                        <ng-container matColumnDef="assign">
                          <th mat-header-cell *matHeaderCellDef class="assign"></th>
                          <td mat-cell *matCellDef="let mapelement" class="assign">
                            <div class="flex-box-vc-hl">
                              <button class="transparent-btn no-pad assign-btn"
                                (click)="openUnAssignPopUp(mapelement, 'single')"
                                *ngIf="mapelement.isunassign === 'true'">
                              </button>
                            </div>
                          </td>
                        </ng-container>
                        <tr mat-header-row *matHeaderRowDef="bulkmappingColumns; sticky: true"></tr>

                        <tr mat-row *matRowDef="let row; columns: bulkmappingColumns;" cdkDrag [cdkDragData]="row"
                          cdkDragLockAxis="y" class="draggable-row" cdkDragBoundary=".table-body"
                          (mouseover)="row.selected = true" (mouseout)="row.selected = false"></tr>
                      </table>
                    </ng-container>
                  </div>
                </mat-expansion-panel>
              </ng-container>
            </mat-accordion>

          </div>
        </div>
      </div>
    </div>
    <div class="map-btns">
      <!-- <button class="flat-btn cancl-btn" mat-stroked-button [mat-dialog-close] (click)="cancelBulkMap()">Cancel</button> -->
      <button class="close-button" mat-flat-button color="primary" [mat-dialog-close] (click)="cancelBulkMap()">
        Close
      </button>

    </div>
    <ng-container *ngIf="singleUnAssignMessage || allUnAssignMessage">
      <div class="alert-dialg">
        <div class="float-left alert-dialg-left">
          <p class="no-marg" *ngIf="allUnAssignMessage">
            Are you sure you want to unassign map numbers from all the selected accounts?
          </p>
          <p class="no-marg" *ngIf="singleUnAssignMessage">
            Are you sure you want to unassign map number from the selected account?
          </p>
        </div>
        <div class="float-right alert-dialg-right">
          <button class="flat-btn nobtn" mat-stroked-button (click)="onUnAssignNo()">No</button>
          <button class="flat-btn" color="primary" mat-flat-button (click)="onUnAssignYes()">Yes</button>
        </div>
      </div>
    </ng-container>
  </div>
</ng-template>
<mat-menu #allMenu="matMenu" xPosition="before" (click)="$event.stopPropagation()">
  <button mat-menu-item (click)="$event.stopPropagation();editMapNo()" class="mat-menu-item">
    <span class="flexbox-row gap-8">
      <i class="fa-regular fa-pen fs-15"></i>
      <span class="button-label">Edit</span>
    </span>
  </button>
  <button mat-menu-item (click)="$event.stopPropagation();deletedialog('all')" class="mat-menu-item">
    <span class="flexbox-row gap-8">
      <i class="fa-regular fa-trash-can"></i>
      <span class="button-label">Delete</span>
    </span>
  </button>
</mat-menu>
<mat-menu #newMenu="matMenu" xPosition="before" (click)="$event.stopPropagation()">
  <button mat-menu-item (click)="$event.stopPropagation();editMapNo()" class="mat-menu-item">
    <span class="flexbox-row gap-8">
      <i class="fa-regular fa-pen fs-15"></i>
      <span class="button-label">Edit</span>
    </span>
  </button>
  <button mat-menu-item (click)="$event.stopPropagation();deletedialog('new')" class="mat-menu-item">
    <span class="flexbox-row gap-8">
      <i class="fa-regular fa-trash-can"></i>
      <span class="button-label">Delete</span>
    </span>
  </button>
</mat-menu>
